import { SingleOrArray } from "@dirootie-extensions/typescript";
import * as R from 'ramda';
import { Kvp,PathNotation,mapToPairs, normalizePath } from "../paths";
import { assocPath, find, prop, head, filter, propEq, map } from 'ramda';
import { isNotUndefined } from "ramda-adjunct";

export const propOrPath = <T>(path: SingleOrArray<string>) =>
  R.path<T>(normalizePath(path));


export const setPropOrPath = <T,TP>(path: SingleOrArray<string>, value: TP, obj: T) => {
  const p = normalizePath(path);
  const r =  assocPath<TP,T>(normalizePath(p), value)(obj);
  return r;
}


export const findFirstPairDefined = (props: any[], target: Record<string,any>) =>{
  const pairs = mapToPairs<Kvp>(props,target);
  try {
    const result = find(x => x?.value !== undefined, pairs);
    return result;
  }
  catch (e) {
    console.log("EXCEPTION",e,pairs);
  }
}


export const findFirstValueDefined = <T>(props: PathNotation[], target: Record<string,any>, defaultValue:T) => {
  const result = findFirstPairDefined(props,target) as Kvp<T> | undefined;
  return (result ? result.value : defaultValue) as T;
}

export const findFirstValueDefinedFromArray = (propName: any, arr:any[]) => {
    const result = prop("value",
      head(filter((x:any) => propEq(propName,"key")(x) && isNotUndefined(prop("value",x)),arr)));
    return result;
}

export const selectNonEmptyValues = (props: string[],obj: Record<string,any>) => map(prop("value"),selectNonEmptyEntries(props,obj));
export const selectNonEmptyEntries = (props: any[],obj: Record<string,any>) => filter((x) => isNotUndefined(prop("value",x)),mapToPairs<Kvp>(props,obj)) || undefined;
